import { UserI } from "@services/getUsers";
import { IAuthorization } from "@store/auth/actionTypes";
import { useIntl } from "react-intl";

export const OWNER_BACK_ID = "0000-0000";

function getEmail(user: UserI | IAuthorization) {
  if (user.email) {
    if (typeof user.email === "object") {
      return user.email.value || "";
    }
    return user.email;
  }
  return "";
}

function isTechnical(user: UserI | IAuthorization): boolean {
  if ((user as UserI).Urole !== undefined) {
    return (user as UserI).Urole === "t";
  }
  if ((user as IAuthorization).role !== undefined) {
    return (user as IAuthorization).role === "t";
  }
  return false;
}

export function formatUser(
  user: UserI | IAuthorization,
  formatter: ReturnType<typeof useIntl>['formatMessage'],
): string {
  const isTech = isTechnical(user);
  let result = isTech ? "" : user.name ?? "";
  const email = getEmail(user);
  if (email) {
    if (result !== "") {
      result += ` - ${email}`;
    } else {
      result = email;
    }
  }
  if (isTech) {
    return result;
  }
  const minersCount = (user.m_low ?? 0) + (user.m_offline ?? 0) + (user.m_online ?? 0);
  return `${result} - ${formatter({ id: "CustomerSelector.miners_count" })} (${minersCount})`;
}